const translations = {
  "en": {
    "Critical issue": "Critical",
    "Important issue": "Important",
    "Minor issue": "Minor"
  },
  "zh-tw": {
    "Critical issue": "關鍵",
    "Important issue": "重要",
    "Minor issue": "次要"
  }
};

export default translations;
